<!-- <main class="auth-page">
  <section class="auth-card">
    <a routerLink="/" class="logo">MeuCardápio</a>

    <h1>Entrar</h1>
    <p>Acesse sua conta para acompanhar seus pedidos.</p>

    <label>E-mail</label>
    <input [(ngModel)]="email" type="email" placeholder="seuemail@email.com">

    <label>Senha</label>
    <input [(ngModel)]="password" type="password" placeholder="Sua senha">

    <button [disabled]="loading" (click)="login()">
      {{ loading ? 'Entrando...' : 'Entrar' }}
    </button>

    <div class="error" *ngIf="error">{{ error }}</div>

    <p class="link">
      Ainda não tem conta?
      <a routerLink="/customer/register">Criar conta</a>
    </p>
  </section>
</main> -->



<main class="auth-page">

  <section class="auth-shell">

    <div class="auth-brand">

      <a routerLink="/" class="logo">
        <span class="logo-mark">
          🍽️
        </span>

        <span>
          MeuCardápio
        </span>
      </a>

      <div class="brand-content">

        <span class="brand-tag">
          Seu pedido, mais simples.
        </span>

        <h2>
          Acompanhe seus pedidos
          de um jeito rápido e fácil.
        </h2>

        <p>
          Entre na sua conta para acompanhar
          pedidos, acessar seu histórico e
          continuar sua experiência no restaurante.
        </p>

      </div>

      <div class="brand-decoration">
        <div class="decoration-card">
          <span>🍔</span>
          <strong>Escolha</strong>
          <small>Seu pedido em poucos toques</small>
        </div>

        <div class="decoration-card">
          <span>🧾</span>
          <strong>Acompanhe</strong>
          <small>Status do pedido em tempo real</small>
        </div>
      </div>

    </div>


    <section class="auth-card">

      <div class="mobile-logo">
        <a routerLink="/" class="logo">
          <span class="logo-mark">
            🍽️
          </span>

          <span>
            MeuCardápio
          </span>
        </a>
      </div>

      <div class="auth-header">

        <span class="eyebrow">
          Área do cliente
        </span>

        <h1>
          Bem-vindo de volta
        </h1>

        <p>
          Entre para acompanhar seus pedidos.
        </p>

      </div>


      <div
        class="error"
        *ngIf="error"
      >
        <span class="error-icon">
          !
        </span>

        <span>
          {{ error }}
        </span>
      </div>


      <div class="form-field">

        <label for="customer-email">
          E-mail
        </label>

        <div class="input-wrapper">

          <span class="input-icon">
            ✉
          </span>

          <input
            id="customer-email"
            [(ngModel)]="email"
            type="email"
            autocomplete="email"
            placeholder="seuemail@email.com"
          >

        </div>

      </div>


      <div class="form-field">

        <div class="label-row">

          <label for="customer-password">
            Senha
          </label>

        </div>

        <div class="input-wrapper">

          <span class="input-icon">
            🔒
          </span>

          <input
            id="customer-password"
            [(ngModel)]="password"
            type="password"
            autocomplete="current-password"
            placeholder="Digite sua senha"
            (keyup.enter)="login()"
          >

        </div>

      </div>


      <button
        type="button"
        class="login-button"
        [disabled]="loading"
        (click)="login()"
      >

        <span *ngIf="!loading">
          Entrar
        </span>

        <span
          class="loading-button"
          *ngIf="loading"
        >
          <span class="spinner"></span>
          Entrando...
        </span>

      </button>


      <div class="separator">

        <span>
          ou
        </span>

      </div>


      <div class="register-box">

        <div>
          <strong>
            Ainda não tem uma conta?
          </strong>

          <span>
            Cadastre-se em poucos segundos.
          </span>
        </div>

        <a
          routerLink="/customer/register"
          class="register-link"
        >
          Criar conta
        </a>

      </div>


      <p class="auth-footer">
        Ao entrar, você poderá acompanhar seus pedidos
        e sua experiência no restaurante.
      </p>

    </section>

  </section>

</main>